module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-0a7157ddc32208b48084f97688790f6d.png";